import { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SalesReportView } from '@/components/sales/SalesReportView';

export function SalesReportPage() {
  const { nip } = useParams<{ nip: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  // Same mechanism as SalesPage: carry the query string (URL-persisted month)
  // into the detail page; listPath makes its "back" return to the REPORT, not
  // the main sales list.
  const handleInvoiceSelect = useCallback(
    (invoiceId: string) => {
      navigate(`/${nip}/invoices/${invoiceId}`, {
        state: { listSearch: location.search, listPath: 'sales/report' },
      });
    },
    [nip, navigate, location.search],
  );

  // Clear the refetch flag InvoiceDetailPage sets after a save, so a page
  // refresh doesn't re-trigger anything — same pattern as SalesPage.
  useEffect(() => {
    if (location.state?.refetch) {
      navigate(location.pathname + location.search, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, location.search, navigate]);

  return <SalesReportView companyNip={nip || ''} onInvoiceSelect={handleInvoiceSelect} />;
}
